<template>
  <div>
    <Chart @tooltip="onTooltip" class="mt-5 mt-sm-0" />
    <Tooltip :asset="asset" :top="tooltipTop" :left="tooltipLeft" />
    <Legend @tooltip="onTooltipLegend" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "@/components/charts/AssetValueShareChart.vue";
import Tooltip from "@/components/specials/AssetValueShareTooltip.vue";
import Legend from "@/components/specials/AssetValueShareLegend.vue";

export default {
  components: {
    Chart,
    Tooltip,
    Legend,
  },
  data() {
    return {
      asset: {},
      tooltipTop: 0,
      tooltipLeft: 0,
    };
  },
  computed: {
    assets() {
      return this.profitlossMode
        ? this.portfolioAssetsSortedByShare_pl
        : this.portfolioAssetsSortedByShare;
    },
    ...mapGetters({
      profitlossMode: "settings/profitlossMode",
      portfolioAssetsSortedByShare: "portfolio/portfolioAssetsSortedByShare",
      portfolioAssetsSortedByShare_pl:
        "profitloss/portfolioAssetsSortedByShare",
    }),
  },
  methods: {
    onTooltip(tooltipModel) {
      if (tooltipModel.opacity === 0) {
        this.asset = {};
      } else {
        this.tooltipLeft = tooltipModel.caretX;
        this.tooltipTop = tooltipModel.caretY;
        const toolTipKey = tooltipModel.dataPoints[0].index;
        this.asset = this.assets[toolTipKey];
      }
    },
    onTooltipLegend(asset) {
      this.tooltipLeft = 0;
      this.tooltipTop = 0;
      this.asset = asset;
    },
  },
};
</script>
